import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { variantWidth } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Veřejná stránka sdílených fotek — bez přihlášení. Obrázky přes tokenovanou
// cestu (obyčejný <img>, ne SignedImg). Po expiraci hláška z 410.
export default function PublicShare() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });
  // 216: dlaždice = náhled, ne originál (mobil 2 sloupce, od md: 4 sloupce)
  const w = variantWidth(typeof window !== "undefined" && window.innerWidth < 768 ? 200 : 360);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${BACKEND}/api/share/${token}`);
        if (r.status === 410) return setState({ loading: false, expired: true });
        if (!r.ok) return setState({ loading: false, error: true });
        setState({ loading: false, data: await r.json() });
      } catch { setState({ loading: false, error: true }); }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="public-share-page">
      <header className="border-b border-border px-4 py-4">
        <h1 className="text-xl font-black tracking-tight">Fotky ze stavby — Proyekty</h1>
      </header>
      <div className="p-4">
        {state.loading && <p className="text-muted-foreground">Načítám…</p>}
        {state.expired && <p className="text-muted-foreground" data-testid="share-expired">Platnost odkazu vypršela.</p>}
        {state.error && <p className="text-muted-foreground" data-testid="share-error">Odkaz nenalezen.</p>}
        {state.data && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-testid="share-grid">
            {state.data.photos.map((p) => (
              <div key={p.id} className="rounded-[12px] overflow-hidden border border-border bg-secondary aspect-square">
                <img src={`${BACKEND}/api/share/${token}/photo/${p.id}${w ? `?w=${w}` : ""}`} alt={p.caption || ""} loading="lazy" decoding="async"
                  className="w-full h-full object-cover" data-testid={`share-photo-${p.id}`} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
